var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconQuoteEnd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 25,
    viewBox: "0 0 31 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.138947 18.6914V24.6913C0.138947 24.6913 12.3289 24.6913 12.3289 12.6915L12.3289 0.691591H0.138947L0.138947 12.6915H6.23393C6.23393 12.6915 6.23393 18.6914 0.138947 18.6914V18.6914ZM30.6129 12.6912L30.6129 0.69132H18.4229L18.4229 12.6912L24.5179 12.6912C24.5179 12.6912 24.5179 18.6911 18.4229 18.6911V24.691C18.4229 24.691 30.6129 24.691 30.6129 12.6912V12.6912Z",
    fill: "#005DA2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuoteEnd);
export default __webpack_public_path__ + "static/media/Icon-quote-end.5279a08942ea68bb2d11414b540ceee4.svg";
export { ForwardRef as ReactComponent };